module.exports = function(exec){
  try {
    return !!exec();
  } catch(e){
    return true;
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/library/modules/$.fails.js
// module id = 93
// module chunks = 174 178 179 182 193 194 195